import { useMatchedLegacyRoute } from "../hooks/useMatchedLegacyRoute";
import { useEffect } from "react";

export const LegacyRedirect = () => {
  const route = useMatchedLegacyRoute();

  useEffect(() => {
    if (route) {
      window.location.replace(route)
    }
  }, [route])

  return null;
}